
import axios from 'axios';
const qs = require('qs');
export const signIn = (username, password) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: 'https://hub.akschap.com/api/user/login?time=' + Date.now(),
            data: qs.stringify({ username: username, password: password })
        })
            .then(res => {
                return resolve(res.data.data);
            }).catch(function (error) {
                return reject(error);
            });
    });
};

export const signOut = (uid, hash) => {
    return new Promise((resolve, reject) => {
        return true;
        // axios.get('http://top.akschap.com/api/user/login.php?uid=' + uid + "&hash=" + hash)
        //     .then(res => {
        //         return resolve(res.data);
        //     }).catch(function (error) {
        //         return reject(error);
        //     });
    });
};
